/**
 * Identity and Access Management
 * CIAM (Customer Identity and Access Management) API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = General, 1 = ProductManagement, 2 = DeviceManagement, 3 = Security, 4 = Administration
 */
export enum OrganizationFeatureCategories {
    General = 'general',
    ProductManagement = 'product_management',
    DeviceManagement = 'device_management',
    Security = 'security',
    Administration = 'administration'
}

